import React, { useEffect, useState } from 'react';
import EquipmentsActive from '../../../../assets/images/conroller_active.svg';
import Equipments from '../../../../assets/images/controller.svg';
import { Button } from '@mui/material';
import EquipmentsNameEdit from './equipmentsNameEdit';
import { useHook as EquipmentHook } from './useHook';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setGetControllerDetails } from '../../../../stores/actionTypes/controllerActions';
import EquipmentsParamEdit from './equipmentsParamEdit';
import EquipmentsAlertsEdit from './equipmentsAlertsEdit';
import { Unauthorized } from '../../../../components/index';
import { ErrorMessage } from '../../../../permissionErrorMessage/PermissionMessage';
interface Props {
  pagePermissionIDs: unknown;
}
const CreateEquipments: React.FC<Props> = ({ pagePermissionIDs }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [equipmentsPage, setEquipmentsPage] = useState('basicDetails');
  const [equipmentsPayload, setEquipmentsPayload] = useState({});
  const canCategorielistPermission =
    Array.isArray(pagePermissionIDs) &&
    pagePermissionIDs.includes('categories::list');

  const canRolelistPermission =
    Array.isArray(pagePermissionIDs) &&
    pagePermissionIDs.includes('roles::list');

  const canControllerlistPermission =
    Array.isArray(pagePermissionIDs) &&
    pagePermissionIDs.includes('controllers::list');

  const requiredAccess = (
    <section className="required_access_section">
      <p>you require below access:</p>
      <ul>
        <li>{ErrorMessage['categories::list'] || ''}</li>
        <li>{ErrorMessage['roles::list'] || ''}</li>
        <li>{ErrorMessage['controllers::list'] || ''}</li>
      </ul>
    </section>
  );

  const { createEquipment } = EquipmentHook();
  useEffect(() => {
    dispatch(setGetControllerDetails({}));
  }, []);

  const formSubmit = (data: any) => {
    setEquipmentsPayload(data);
    setEquipmentsPage('SpecifyParameters');
  };

  const handleCreateEquipment = async (alerts: any) => {


    const payload = {
  ...equipmentsPayload,
    events: alerts.map((alert:any) => ({
      eventType: alert.eventType,
      value: alert.values.reduce((acc: any, curr: any, index: number) => {
        acc[curr.value] = {
          title: curr.title,
          desc: curr.desc,
          icon: curr.icon,
          channels: curr.channels,
        };
        return acc;
      }, {}),
    })),
  };
  

  // return
   
    await createEquipment(payload);
    navigate(-1);
  };

  return (
    <>
      {!canCategorielistPermission ||
      !canRolelistPermission ||
      !canControllerlistPermission ? (
        <Unauthorized requiredAccess={requiredAccess} />
      ) : (
        <>
          <div className="hardware-equipment">
            <div className="create_controller_header">
              <Button
                onClick={() => setEquipmentsPage('basicDetails')}
                className={
                  equipmentsPage === 'basicDetails'
                    ? 'create_controller_header controller-active'
                    : 'create_controller_header'
                }
              >
                <img
                  src={
                    equipmentsPage === 'basicDetails'
                      ? EquipmentsActive
                      : Equipments
                  }
                  width={40}
                  alt="User Profile"
                />{' '}
                <p>Basic Details</p>
              </Button>
              <div className="create_controller_header-line"></div>
              {equipmentsPage ==="basicDetails" ?
                  <div
               
                className={
                  !(equipmentsPage === 'basicDetails') && !(equipmentsPage === 'addAlerts')
                    ? 'create_controller_header controller-active'
                    : 'create_controller_header'
                }
              >
                <img
                  src={
                    !(equipmentsPage === 'basicDetails') && !(equipmentsPage === 'addAlerts')
                      ? EquipmentsActive
                      : Equipments
                  }
                  width={40}
                  alt="User Profile"
                />{' '}
                <p>Specify Parameters</p>
              </div>:
                  <Button
                onClick={() => setEquipmentsPage('SpecifyParameters')}
                className={
                  !(equipmentsPage === 'basicDetails') && !(equipmentsPage === 'addAlerts')
                    ? 'create_controller_header controller-active'
                    : 'create_controller_header'
                }
              >
                <img
                  src={
                    !(equipmentsPage === 'basicDetails') && !(equipmentsPage === 'addAlerts')
                      ? EquipmentsActive
                      : Equipments
                  }
                  width={40}
                  alt="User Profile"
                />{' '}
                <p>Specify Parameters</p>
              </Button>
              }
            
   <div className="create_controller_header-line"></div>
                <div
                className={
                  (equipmentsPage === 'addAlerts')
                    ? 'create_controller_header controller-active'
                    : 'create_controller_header'
                }
              >
                <img
                  src={
                    (equipmentsPage === 'addAlerts')
                      ? EquipmentsActive
                      : Equipments
                  }
                  width={40}
                  alt="User Profile"
                />{' '}
                <p>Add Events</p>
              </div>
            </div>

            {equipmentsPage === 'basicDetails' ? (
              <EquipmentsNameEdit
                formSubmit={formSubmit}
                pagePermissionIDs={pagePermissionIDs}
              />
            ) : equipmentsPage === 'SpecifyParameters'? (
              <EquipmentsParamEdit formSubmit={handleCreateEquipment}
                setEquipmentsPayload={setEquipmentsPayload}
    setEquipmentsPage={setEquipmentsPage}
    equipmentsPayload={equipmentsPayload}
               />
            ):
            (
              <EquipmentsAlertsEdit
              formSubmit={handleCreateEquipment}
                setEquipmentsPayload={setEquipmentsPayload}
    setEquipmentsPage={setEquipmentsPage}
    equipmentsPayload={equipmentsPayload}
               />
            )
          }
          </div>
        </>
      )}
    </>
  );
};

export default CreateEquipments;
